import { properties } from '@/utils/properties';
import { Util } from '@/utils/util';
import { Component, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { CatalogoCodigoEquipoService } from '@services/catalogo/catalogoCodigoEquipo.service';
import { FormularioCodigoEquipoComponent } from './formulario-codigo-equipo/formulario-codigo-equipo.component';
import { CodigoEquipoModel } from '@/store/catalogos/codigoEquipo';
import { FormularioCodigoEquipoCaracteristicaComponent } from './formulario-codigo-equipo-caracteristica/formulario-codigo-equipo-caracteristica.component';


@Component({
  selector: 'app-codigo-equipo',
  templateUrl: './codigo-equipo.component.html',
  styleUrls: ['./codigo-equipo.component.scss']
})
export class CodigoEquipoComponent {
 PROP = properties;
  displayedColumns: string[] = ['nombreEquipo', 'procCali','options'];
  dataSource = new MatTableDataSource<any>([]);
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private paginator1: MatPaginatorIntl,
    private codigoEquipoService: CatalogoCodigoEquipoService,
    public dialog: MatDialog,
    private util: Util) {
    this.paginator1.itemsPerPageLabel = "Registros por página";
  }

  ngOnInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this. loadCodigoEquipos();

  }

  filterTable(event: Event) {
    const filtro = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filtro.trim().toLowerCase();
  }

  loadCodigoEquipos() {
    this.codigoEquipoService.getAll().subscribe(data => {
      this.dataSource = new MatTableDataSource(data);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
    });

  }


  new() {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:null}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadCodigoEquipos();
      }
    });
  }

  update(row: CodigoEquipoModel) {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:true,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadCodigoEquipos();
      }
    });
  }

  
  settings(row: CodigoEquipoModel) {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoCaracteristicaComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:true,update:false,view:false,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadCodigoEquipos();
      }
    });
  }

  view(row: CodigoEquipoModel) {
    const dialogRef = this.dialog.open(FormularioCodigoEquipoComponent, {
      width: '80%',
      maxWidth: 'none',
      height: 'auto',
       disableClose: true, data:{insert:false,update:false,view:true,row:row}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (!this.util.isEmpty(result) && result.data.success) {
        this.loadCodigoEquipos();
      }
    });
  }

}
